module.exports = __webpack_public_path__ + "img/CM-CA-112122-Ford-Playful.59a8df8a.jpg";